import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

const get = (url, params) => api.get(url, { params }).then((r) => r.data);

export const useApi = (key, url, params, opts = {}) =>
  useQuery({ queryKey: [key, params ?? null], queryFn: () => get(url, params), ...opts });

const LIVE = { staleTime: 0 };

export const useItems = () => useApi("items", "/catalogue/items");
export const useCategories = () => useApi("categories", "/catalogue/categories");
export const usePrices = () => useApi("prices", "/prices");
export const useLastBought = () => useApi("lastBought", "/catalogue/last-bought", undefined, LIVE);
export const useDelivery = () => useApi("delivery", "/delivery/me", undefined, LIVE);
export const useOrders = () => useApi("orders", "/orders", undefined, LIVE);
export const useOrder = (id) => useApi("order", `/orders/${id}`, undefined, LIVE);
export const useLists = () => useApi("lists", "/lists");
export const useContent = () => useApi("content", "/content/customer");
export const usePromotions = () => useApi("promotions", "/promotions/me");
export const usePreseason = (enabled = true) => useApi("preseason", "/preseason/me", undefined, { ...LIVE, enabled });
export const useInsights = (from, to, code) => useApi("insights", "/insights", { date_from: from, date_to: to, ...(code ? { customer_code: code } : {}) }, { enabled: !!from && !!to && from <= to });
export const useCustomer = (code) => useApi("customer", `/customers/${code}`);
export const useStatement = (from, to, enabled = true) =>
  useApi("statement", "/finance/statement", { date_from: from, date_to: to }, { ...LIVE, enabled });
export const usePayments = (enabled = true) => useApi("payments", "/finance/payments", undefined, { ...LIVE, enabled });
export const useOpenInvoices = (enabled = true) => useApi("openInvoices", "/finance/open-invoices", undefined, { ...LIVE, enabled });

export const useShop = () => {
  const items = useItems();
  const prices = usePrices();
  return useMemo(() => {
    const priceMap = Object.fromEntries((prices.data || []).map((p) => [p.item_code, p]));
    const byCode = Object.fromEntries((items.data || []).map((i) => [i.code, i]));
    const sellable = (items.data || []).filter((i) => priceMap[i.code]);
    return { isLoading: items.isLoading || prices.isLoading, isError: items.isError || prices.isError, priceError: prices.error, priceMap, byCode, sellable };
  }, [items.data, prices.data, items.isLoading, prices.isLoading, items.isError, prices.isError]);
};

export const errorDetail = (err) => err?.response?.data?.detail || "";
